import { Editor } from 'slate';
import { useSlate } from 'slate-react';
import useSelectedBlock from './useSelectedBlock';

const MARKS = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'code',
    'superscript',
    'subscript',
    'highlight',
    'link',
    'dir',
    'textAlign',
    'color',
    'backgroundColor',
    'fontSize',
    'fontFamily',
];

const useMark = () => {
    const editor = useSlate();

    const { type } = useSelectedBlock();

    const getMark = format => Editor.marks(editor)?.[format];

    const clearMarks = () => {
        MARKS.forEach(format => Editor.removeMark(editor, format));
    };

    const setMark = (format, value) => {
        if (value) {
            Editor.addMark(editor, format, value);
        } else {
            Editor.removeMark(editor, format);
        }
    };

    const getFallbackValue = format => {
        const fallbackType = [
            'heading-one',
            'heading-two',
            'heading-three',
            'heading-four',
        ].includes(type)
            ? type
            : 'paragraph';
        const fallbackValue =
            editor.children[0].globalStyles[fallbackType]?.[format];
        return fallbackValue;
    };

    return { clearMarks, getMark, setMark, getFallbackValue };
};

export default useMark;
